<template>
  <div class="service_detail_wrapper">
    <div class="header">
      <div>
        <a-button icon="arrow-left" size="small" @click="() => $router.back()" />
        <span class="page_type">详情</span>
      </div>
    </div>
    <div class="content">
      <div class="common flex-row">
        <div class="left">
          <div class="basic-info">
            <div class="img-wrapper">
              <a-avatar shape="square" :size="26" :src="titlePrefix" />
            </div>
            <div>
              <div class="code">
                <span style="display: inline-block; width: 15em;">售后单号：{{ detailInfo.afterCode }}</span>
                <span :class="`status-${detailInfo.state}`">
                {{ convertToName(executionStatusGroup, detailInfo.state) }}
                </span>
              </div>
              <div class="customer">{{ detailInfo.unit }}</div>
            </div>
          </div>
          <a-tabs default-active-key="1" @change="handleActiveChange">
            <a-tab-pane key="1" tab="售后信息">
            </a-tab-pane>
            <a-tab-pane key="2" tab="日志动态">
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <template v-if="activeKey === '1'">
        <div class="common">
          <div class="title gap-12">基本信息</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="销售合同编号">{{
              detailInfo.pcCode | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="销售订单号">{{
              detailInfo.orderCode | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后申请单号">{{
              detailInfo.afterCode | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="客户抬头">{{
              detailInfo.unit | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="客户联系人">{{
              detailInfo.salesmanName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{
              detailInfo.salesmanPhone | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后类型">{{
              detailInfo.typeName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后原因">{{
              detailInfo.reason | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后申请状态">{{
              detailInfo.stateName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item v-if="[7, '7'].includes(detailInfo.state)" label="驳回原因">{{
              detailInfo.supIdea | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item v-if="Number(returnType) !== 1" label="退款金额">{{
              detailInfo.refundAmout && detailInfo.refundAmout.toLocaleString('en-US', { minimumFractionDigits: 2 })
            }}</el-descriptions-item>
            <el-descriptions-item v-if="Number(returnType) !== 1" label="收款账号">{{
              detailInfo.account | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item v-if="Number(returnType) === 1 || Number(returnType) === 3" label="退货收货信息">{{
              detailInfo.detailAddress | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="售后创建时间">{{
              detailInfo.createTime | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{
              detailInfo.remark | setEmpty
            }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div v-if="Number(returnType) === 1 || Number(returnType) === 3" class="common">
          <div class="title gap-12">退货信息</div>
          <template v-if="detailInfo.sellerAfterSerRepDtoList && detailInfo.sellerAfterSerRepDtoList.length">
            <xz-table
              ref="xzTable"
              :columns="columnList"
              :data="detailInfo.sellerAfterSerRepDtoList"
              rowKey="id"
              style="margin-top: -10px;">
              <template slot="imageList" slot-scope="image">
                <span v-if="image && image.split(',').length > 0">
                  <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                    <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
                  </span>
                  <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
                </span>
                <span v-else>暂无图片</span>
              </template>
              <template slot="tdAction" slot-scope="currentReturnNum, row">
                <div @click="handleShowReturnDialog(row)" style="color: #237FFA; cursor: default;">{{ currentReturnNum }}</div>
              </template>
              <template slot="footer" slot-scope="currentPageData">
                <div>
                  <b style="margin-right: 100px;">合计</b>
                  <b style="margin-right: 5px;">数量：{{ currentPageData.reduce((pre, cur) => pre + Number(cur.currentReturnNum), 0) || '-' }}</b>
                  <b>，总金额：{{ currentPageData.reduce((pre, cur) => pre + cur.currentReturnNum * cur.unitPrice, 0).toLocaleString('en-US', { minimumFractionDigits: 2 }) || '-' }}</b>
                </div>
              </template>
            </xz-table>
          </template>
          <Empty v-else />
        </div>
      </template>
      <template v-if="activeKey === '2'">
        <div class="common" style="padding-top: 0;">
          <xz-table ref="xzTable" :columns="logColumns" :data="logData" rowKey="id"></xz-table>
        </div>
      </template>
    </div>
    <bottom-panel v-if="type !== 'detail' && $withPermission('gongxutong:sale_after:order:audit')">
      <label style="float: left">
        <span class="common-font">审批意见：</span>
        <el-input
          placeholder="请输入审批意见"
          v-model.trim="approveMsg"
          style="width: 500px"
          maxlength="50"
        ></el-input>
      </label>
      <template>
        <el-button
          style="margin-left: 1em"
          type="danger"
          plain
          @click="doApprove('reject')"
          >驳回</el-button
        >
        <el-button type="primary" @click="doApprove('pass')">通过</el-button>
      </template>
    </bottom-panel>
    <ReturnDialog ref="returnDialogRef" />
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import {
  editState,
  view,
} from '@/api/service';
import setTableCols from './configs';
import BottomPanel from '@/components/common/bottomPanel';
import ReturnDialog from '../components/returnDialog.vue';
import Empty from '@/components/empty.vue';
import { logTypes } from '@/model/logTypes';
import { queryLogListById } from '@/api/saleContract';
import {
  executionStatusGroup,
  typeStatusOptions,
} from '@/model/service';

export default {
  name: 'service_detail',
  components: {
    Empty,
    xzTable,
    BottomPanel,
    ReturnDialog,
  },
  props: {
    id: {
      type: String,
    },
    outRefundId: {
      type: String,
    },
    type: {
      type: String,
    },
    returnType: {
      type: [String, Number],
    },
  },
  filters: {
    setEmpty (val) {
      return val ? val : '--';
    },
  },
  data () {
    return {
      titlePrefix: require('@/assets/title_prefix.svg'),
      activeKey: '1',
      executionStatusGroup,
      visible: false,
      approveMsg: '',
      detailInfo: {
        sellerAfterSerRepDtoList: [],
      },
      columnList: [
        ...setTableCols.call(this, 'serviceDetail'),
        {
          title: '注册证号',
          dataIndex: 'regNo',
          key: 'regNo',
          width: 120,
          ellipsis: true,
          customRender: text => {
            return text || '--';
          },
        },
        {
          title: '退货数量',
          dataIndex: 'currentReturnNum',
          key: 'currentReturnNum',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'tdAction' },
        },
      ],
      logData: [],
      logColumns: [
        {
          title: '事件类型',
          dataIndex: 'logType',
          key: 'logType',
          width: 300,
          customRender: (text) => {
            let val = '--';

            for (let v of logTypes) {
              if (v.value === text) {
                val = v.label;
                break;
              }
            }

            return val;
          },
        },
        {
          title: '时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 300,
          customRender: (text) => {
            return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
          },
        },
        {
          title: '日志内容',
          dataIndex: 'content',
          key: 'content',
        },
      ],
    };
  },
  created () {
    this.getDetail();
    this.getLog();
  },
  methods: {
    convertToName (enums, value) {
      let label = '--';

      for (let v of enums) {
        if (Number(v.value) === Number(value)) {
          label = v.label;
          break;
        }
      }

      return label;
    },
    handleActiveChange (v) {
      this.activeKey = v;
    },
    getName (enums, val) {
      for (let v of enums) {
        if (v.value * 1 === val) {
          return v.label;
        }
      }

      return '';
    },
    getDetail () {
      view({ id: this.outRefundId }).then(({ body }) => {
        this.detailInfo = body;

        this.detailInfo.typeName = this.getName(typeStatusOptions, body.type);
        this.detailInfo.stateName = this.getName(executionStatusGroup, body.state);
        this.detailInfo.detailAddress = `${body.provinceName || ''}${body.cityName || ''}${body.areaName || ''}${body.address || ''}`;
      });
    },
    doApprove (type) {
      let param = {
        id: this.id,
        auditOpinion: this.approveMsg,
        auditResult: type === 'reject' ? 2 : 1,
      };

      editState(param).then(() => {
        this.$message({
          message: type === 'reject' ? '售后已驳回' : '审核通过',
          type: 'success',
        });

        this.$router.back();
      });
    },
    handleShowReturnDialog (row) {
      this.$refs.returnDialogRef.id = this.outRefundId;
      this.$refs.returnDialogRef.getRefundReturnGoods(row);
    },
    getLog () {
      queryLogListById({
        id: this.outRefundId,
      }).then(({ body }) => {
        this.logData = body || [];
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
}
.service_detail_wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 52px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    .page_type {
      font-size: 16px;
      font-weight: bold;
      margin-left: 1em;
    }
  }

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .gap-12 {
      margin-bottom: 12px;
    }

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      &.flex-row {
        display: flex;
        justify-content: space-between;
        padding-right: 0;
        padding-bottom: 0;

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .basic-info {
            display: flex;
            align-items: center;

            .img-wrapper {
              width: 40px;
              height: 40px;
              background-color: #E2F3FE;
              border-radius: 4px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .code {
              font-size: 14px;
              color: #929AA6;

              .status-2 {
                @include tag_round();
                background-color: #E2F3FE;
                color: #237FFA;
              }

              .status-5 {
                @include tag_round();
                color: #1F2733;
                background-color: #F2F4F7;
              }

              .status-3 {
                @include tag_round();
                background-color: #E5FEEB;
                color: #14CA64;
              }

              .status-6 {
                @include tag_round();
                background-color: #FEFEE5;
                color: #FAB007;
              }

              .status-7 {
                @include tag_round();
                background-color: #FEE9E5;
                color: #FF5959;
              }
            }

            .customer {
              font-size: 16px;
              font-weight: 600;
            }
          }

          /deep/ .ant-tabs-bar {
            margin: 0;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin-right: 16px;
              }
            }
          }
        }
      }

      .title {
        font-weight: bold;
      }
    }
  }
}
</style>
